var map = {
	"./white/0.25.svg": 785,
	"./white/0.5.svg": 786,
	"./white/0.75.svg": 787,
	"./white/0.svg": 788,
	"./white/1.svg": 789,
	"./white/10.svg": 790,
	"./white/11.svg": 791,
	"./white/2.svg": 792,
	"./white/3.svg": 793,
	"./white/4.svg": 794,
	"./white/5.svg": 795,
	"./white/6.svg": 796,
	"./white/7.svg": 797,
	"./white/8.svg": 798,
	"./white/9.svg": 799,
	"./yellow/0.25.svg": 800,
	"./yellow/0.5.svg": 801,
	"./yellow/0.75.svg": 802,
	"./yellow/0.svg": 803,
	"./yellow/1.svg": 804,
	"./yellow/10.svg": 805,
	"./yellow/11.svg": 806,
	"./yellow/2.svg": 807,
	"./yellow/3.svg": 808,
	"./yellow/4.svg": 809,
	"./yellow/5.svg": 810,
	"./yellow/6.svg": 811,
	"./yellow/7.svg": 812,
	"./yellow/8.svg": 813,
	"./yellow/9.svg": 814
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 784;